import ApiService from "../ApiService"

export default class DeliveryService {
    static getDetail = async (id) => {
        const instance = await ApiService()
        return instance.get(`/delivery/${id}`)
    }
    static getList = async () => {
        const instance = await ApiService()
        
        return instance.get('/delivery?active_st=true')
    }

    static getDeliveryGroups = async (tenant_id) => {
        const instance = await ApiService();
        return instance.get(`/delivery_package_group?tenant_id=${tenant_id}`);
    }

    static getDeliveryPackages = async (params) => {
        let page, perPage, vendorID;
         page = "?page=1"
         perPage = "&perPage=20"

         if (params?.vendor_id && params?.vendor_id !== "") {
             vendorID = `&vendor_id=${params?.vendor_id}`
         }
        
        const instance = await ApiService();
        return instance.get(`/delivery_package${page || ""}${perPage || ""}${vendorID || ""}`);
    }

    static getDeliveryPackageRates = async (package_id, order) => {
        const instance = await ApiService();
        return instance.post(`/delivery_package/rates/${package_id}`, order)
    }

    static getDeliveryPropertyAll = async (property_id) => {
        const instance = await ApiService();
        return instance.get(`/delivery_package/property/${property_id || "0"}`)
    }

    static getDeliveryTenantAll = async (tenant_id) => {
        const instance = await ApiService();
        return instance.get(`/delivery_package/tenant/${tenant_id || "0"}`)
    }

    static postDeliveryPackage = async (params) => {
        const instance = await ApiService();
        return instance.post(`/delivery_package`, params)
    }

    static patchDeliveryPackage = async ({id, params}) => {
        const instance = await ApiService();
        return instance.patch(`/delivery_package/${id}`, params)
    }

    static putDeliveryPackage = async (data) => {
        const {id, ...params} = data; 
        const instance = await ApiService();
        return instance.put(`/delivery_package/${id}`, params)
    }

    static deleteDeliveryPackage = async (id) => {
        const instance = await ApiService();
        return instance.delete(`/delivery_package/${id}`)
    }

    static postDeliveryPackageProperty = async (params) => {
        const instance = await ApiService();
        return instance.post(`/delivery_package/property`, params)
    }

    static postDeliveryPackageTenant = async (params) => {
        const instance = await ApiService();
        return instance.post(`/delivery_package/tenant`, params)
    }

    static getListDeliveryVendor = async (params) => {
        const instance = await ApiService();
        return instance.get(`/delivery_vendor?keyword=${params?.keyword || ""}`)
    }

    static getPropertyDeliveryVendor = async (property_id) => {
        const instance = await ApiService();
        return instance.get(`/delivery_vendor?property_id=${property_id}`)
    }

    static postDeliveryVendor = async (params) => {
        const instance = await ApiService();
        return instance.post(`/delivery_vendor`, params)
    }

    static patchDeliveryVendor = async ({id, params}) => {
        const instance = await ApiService();
        return instance.patch(`/delivery_vendor/${id}`, params)
    }
}